import { handleRetrieveMembers } from "../../../../redux/specialist-slices/myMembers.slice"
import TablePagination from "../../../../components/common/TablePagination"
import { useChatInitiate } from "../../../../hooks/useChatInitiate"
import TableSkell from "../../../../components/common/TableSkell"
import InputFieldB from "../../../../components/ui/InputFieldB"
import { useDispatch, useSelector } from "react-redux"
import { debounce } from "../../../../utils/helper"
import { useEffect, useRef, useState } from "react"
import Icons from "../../../../assets/js/Icons"
import { NavLink } from "react-router-dom"
import { meberHeaders } from "./data"

import {
  Avatar, Box, IconButton, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography
} from "@mui/material"


function Members() {
  const dispatch = useDispatch()
  const searchRef = useRef(null)
  const [data, setData] = useState({})
  const { initiateGeneralChat } = useChatInitiate()
  const { loadings } = useSelector((state) => state.otherSlice)

  // --------------- Get all members ---------------
  const handleRetrieveAll = async (filters) => {
    const query = {
      limit: 10,
      currentPage: filters?.currentPage || 1,
      search: searchRef?.current?.value || null,
    }

    const response = await dispatch(
      handleRetrieveMembers(query)
    ).unwrap() || {}
    if (response?.members)
      setData(response)
  }

  // --------------- Handle search ---------------
  const handleSearchChange = debounce(() => {
    // handleRetrieveAll()
  }, 1000)

  // --------------- Handle chat initiate ---------------
  const handleChatInitiate = async (receiver) => {
    initiateGeneralChat(receiver)
  }


  useEffect(() => {
    handleRetrieveAll()
    // eslint-disable-next-line
  }, [])

  return (
    <>
      <Box py={5}>
        <Box maxWidth={300}>
          <InputFieldB
            type="text"
            name="search"
            variant="outlined"
            inputRef={searchRef}
            placeholder="Search..."
            onChange={handleSearchChange}
          />
        </Box>
      </Box>

      <Paper variant="contentListing">
        <TableContainer variant="tableViewA">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {meberHeaders?.map((element, i) => (
                  <TableCell key={i} align="left">{element}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loadings?.retrieveAll ? (
                <TableSkell colLength={meberHeaders?.length} />
              ) : (
                data?.members?.map((element, i) => (
                  <TableRow
                    key={i}
                    sx={{ td: { borderBottomWidth: i === data?.members?.length - 1 ? "0" : "1px" } }}
                  >
                    <TableCell>
                      <Avatar sx={{ height: 35, width: 35 }} src={element?.memberInfo?.image} />
                    </TableCell>
                    <TableCell sx={{ textTransform: "capitalize" }}>{element?.memberInfo?.name}</TableCell>
                    <TableCell>{element?.memberInfo?.bloodGroup || "N/A"}</TableCell>
                    <TableCell>{element?.totalAppointments || 0}</TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        color="info"
                        title="View Profile"
                        LinkComponent={NavLink}
                        sx={{ p: 0.25, fontSize: 20, mr: 0.5 }}
                        to={`/specialist/profile/member/${element?.memberInfo?._id}`}
                      ><Icons.ViewStrokeStandard />
                      </IconButton>

                      <IconButton
                        size="small"
                        color="info"
                        title="Start chat"
                        sx={{ p: 0.25, fontSize: 20 }}
                        onClick={() => { handleChatInitiate(element?.memberId) }}
                      ><Icons.ChatStrokeRounded />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}

              {!data?.members?.length && !loadings?.retrieveAll && (
                <TableRow sx={{ td: { borderBottom: "none" } }}>
                  <TableCell colSpan={meberHeaders?.length}>
                    <Typography variant="noRecords">No results found!</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          mt={0.001}
          color="primary"
          cb={handleRetrieveAll}
          pagination={data?.pagination}
          loading={loadings?.retrieveAll}
          length={data?.members?.length}
        />
      </Paper>
    </>
  )
}

export default Members